import App from '../../vendor_core/core/src/App';
import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IBuyFeatureConfig from '../../vendor_core/core/src/managers/contracts/configurations/IBuyFeatureConfig';
import BetModel from '../../vendor_core/core/src/model/BetModel';
import Configs from '../../vendor_core/src/vendorConfigs/Configs';

class BuyFeatureConfig implements IBuyFeatureConfig {
    type: ConfigurationTypes = ConfigurationTypes.BUY_FEATURE;
    betMultiplier: number[] = [];
    maxFeaturePurchasePrice?: number = 1000000;
    buyFeatureRtp: number[] = [];
    betOptions = [];
    mode: number = 0;

    public getBetOptions() {
        let result: number[] = [];
        if (this.betOptions.length > 0) {
            /* this.betOptions.forEach(bet => {
                if (BetModel.creditValues.includes(bet)) {
                    result.push(bet)
                }
            }); */
            result = this.betOptions.map(bet => bet / Configs.buyFeature.betMultiplier[0]); // should be 80
        } else if (Configs?.bet) {
            result = Configs.bet.getBetOptions();
        }
        
        return result
    };

    /* public getBetOptions() {
        let result = [];
        if (this.betOptions.length > 0) {
            this.betOptions.forEach(bet => {
                if (this.betOptions.includes(bet)) {
                    result.push(bet)
                }
            })
        } else {
            result = Configs.bet.getBetOptions();
        }

        return result
    }; */

    public parseConfig(data: any) {
        if (data?.buyFeature) {
            this.betMultiplier.push(data.buyFeature);
        }

        if (data?.scatterBoost) {
            this.betMultiplier.push(data.scatterBoost);
        }

        if (data?.buyFreeSpins?.available?.length) {
            this.betOptions = data?.buyFreeSpins.available;
        }

        /* if (data?.config?.buyFeatureCost) {
            this.betMultiplier = typeof data.config.buyFeatureCost === "number"
                ? [data.config.buyFeatureCost]
                : data.config.buyFeatureCost
        } */

        /* if (data?.config?.buyFeatureRtp) {
            let bfRTP = typeof data.config.buyFeatureRtp === "number"
                ? [data.config.buyFeatureRtp * 100]
                : data.config.buyFeatureRtp.map((rtp) => rtp * 100)

            this.buyFeatureRtp = bfRTP;
        } */

        /* if (data?.config?.creditsPerBet) {
            this.creditPerBetBuyFeat = data.config.creditsPerBet[2];
        } */

        /* if (data?.limits?.maxFeaturePurchasePrice) {
            this.maxFeaturePurchasePrice = data.limits.maxFeaturePurchasePrice;
        } */

        /* if (App.config.legalBetsHaveToBeModified) {
            this.betOptions = data.limits.legalBets.map(bet => (bet * this.creditPerBetBuyFeat) / this.betMultiplier[this.mode]);   
        } */
    }
}

export default new BuyFeatureConfig()
